enum CalculationMode {
  CUMULATIVE = 1,
  INCREMENTAL = 2
}

export default CalculationMode
